import React, { Component } from 'react';
import { Col, Row } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import v4 from 'uuid/v4';
import ArticuloFotoGrid from '../../../articulos/containers/BuscadorArticulos';
import { Box } from '../../../shared/components';
import { crearPresupuestoRapido, addArticleToEncargo } from '../../../../state/actions/creators/encargos.actioncreator';
import { encargosType } from '../../types/encargo.types';

class PresupuestoRapidoCreadorPage extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      pantallaActual: 'articulos',
      encargoId: v4(),
      articuloSeleccionadoId: undefined,
    };
  }

  componentDidMount() {
    const { crearPresupuestoRapido } = this.props;
    const { encargoId } = this.state;
    crearPresupuestoRapido({ tiendaId: 0, encargoId });
  }

  onSeleccionarMontura(seleccion) {
    const { addArticleToEncargo, history } = this.props;
    const { articulo, articulo: { id } } = seleccion;
    const { encargoId } = this.state;
    this.setState({ articuloSeleccionadoId: id });
    addArticleToEncargo({ articulo, encargoId, append: false });
    history.push('/presupuestorapido/pel');
  }

  onSeleccionarVR(seleccion) {
    const { addArticleToEncargo, history } = this.props;
    const { articulo, articulo: { id } } = seleccion;
    const { encargoId } = this.state;
    this.setState({ articuloSeleccionadoId: id });
    addArticleToEncargo({ articulo, encargoId, append: false });
    history.push('/presupuestorapido/fittinbox');
  }

  pantallaArticulos() {
    const { articuloSeleccionadoId } = this.state;
    return (
      <Row>
        <Col xs={{ span: 24 }} md={{ span: 15 }}>
          <Box p="8">
            <ArticuloFotoGrid
              numeroDeArticulos={12}
              seleccionId={articuloSeleccionadoId}
              gluedFilter={{ 'tipo.id': { valor: 3, operador: 'eq' }, obsoleto: { valor: 'F', operador: 'eq' } }}
              endpoint="MONTURAS_PRESUPUESTO_RAPIDO"
              ordenable={[{ label: 'Ordenar por nombre', value: 'nombre' }, { label: 'Ordenar por precio', value: 'precio_1' }]}
              onVRClick={seleccion => this.onSeleccionarVR(seleccion) }
              onSeleccion={(seleccion) => this.onSeleccionarMontura(seleccion) }
            />
          </Box>
        </Col>
        <Col xs={{ span: 24 }} md={{ span: 9 }} style={{ position: 'sticky', top: '0' }}>
          <Box p="8">
          </Box>
        </Col>
      </Row>
    );
  }

  render() {
    const { pantallaActual } = this.state;

    return (
      <>
        {
          (pantallaActual === 'articulos') ? this.pantallaArticulos() : null
        }
      </>
    );
  }
}

PresupuestoRapidoCreadorPage.propTypes = {
  encargos: encargosType.isRequired,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ crearPresupuestoRapido, addArticleToEncargo }, dispatch);
}

const mapStateToProps = (state) => {
  const { encargosWorkspace } = state;
  const {
    encargos, resumenPrecios, tituloEspacioDeTrabajo,
  } = encargosWorkspace;
  return {
    encargos,
    resumenPrecios,
    tituloEspacioDeTrabajo,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PresupuestoRapidoCreadorPage);
